"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getLocalLogArguments;
const __1 = require("..");
function getLocalLogArguments(message, metadata) {
    return [
        `[Hypertune] [v${__1.sdkVersion}] ${message}`,
        ...(Object.keys(metadata).length > 0 ? [metadata] : []),
    ];
}
//# sourceMappingURL=getLocalLogArguments.js.map